import { Directive, forwardRef, Inject, Input, Optional, Self, SkipSelf } from '@angular/core';
import { ControlContainer, FormArrayName, NG_ASYNC_VALIDATORS, NG_VALIDATORS } from '@angular/forms';
import { Mixin } from 'eurogard-mixin';
import { ExtractControlMixin } from 'eurogard-form-system';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface FormTableArrayDirective extends ExtractControlMixin {
}

@Mixin(ExtractControlMixin)
@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[rxapFormTableArrayName]',
  providers: [
    {
      provide: ControlContainer,
      useExisting: forwardRef(() => FormTableArrayNameDirective),
    },
  ],
  standalone: true,
})
export class FormTableArrayNameDirective extends FormArrayName {

  @Input({
    alias: 'rxapFormTableArrayName',
    required: true,
  })
  public declare name: string;

  constructor(
    @SkipSelf()
    @Inject(ControlContainer)
    private readonly parent: ControlContainer,
    @Optional() @Self() @Inject(NG_VALIDATORS) validators: any[],
    @Optional() @Self() @Inject(NG_ASYNC_VALIDATORS) asyncValidators: any[],
  ) {
    super(parent, validators, asyncValidators);
  }

}


